import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Switch, Route, Link, useHistory, useLocation, useParams } from 'react-router-dom'
import Select from 'react-select'
import { BiSelectMultiple } from 'react-icons/bi'
import { Drawer, Tabs, DatePicker, Dropdown, Menu, Typography } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import { normalize, useToggle, useListData, usePet, timeDiff, stringifyDate, stringifyTime,patientName, server } from '../../modules'

import images from '../../images'

import Receive from '../reusable/receive'

import EntrySummary from './entrySummary'
import NewSupplier from './newSupplier'
import Confirm from '../reusable/confirm'
import PrintIFrame from '../modals/printIFrame'
import OrderModal from '../modals/ordermodal'

const { TabPane } = Tabs
const { RangePicker } = DatePicker
const { Paragraph } = Typography

const Transactions = ({ id, path }) => {
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState()
    
    const [
        { loading, error, fetch },
        { list: transactions },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('payments', ranges ?
        { string, subject: id, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null }
        : { string, subject: id }
        , { notify: true, manual: false })

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    return (
        <>
            <div className="col-span-full xl:col-span-8 bg-white">
                <div className="sm:flex sm:justify-between sm:items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-search"
                        type="text"
                        placeholder="Search using transaction ref" />
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <RangePicker
                            onChange={selectRange}
                            ranges={{
                                'Today': [moment().startOf('day'), moment().endOf('day')],
                                'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                                'This Week': [moment().startOf('week'), moment().endOf('week')],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                            }} />
                    </div>
                </div>
                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    {
                        transactions.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Amount</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Details</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Description</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Recorded By</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        transactions.map((transaction, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        { ((page - 1) * limit) + (key + 1)}
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">Ksh. {transaction?.amount}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{transaction?.method}</div>
                                                    { transaction?.ref && <p className="text-gray-700 text-xs italic mb-0">#{ transaction?.ref }</p> }
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{transaction?.description}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{transaction?.recordedBy?.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-left">{stringifyDate(transaction.date)}</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No transactions were found</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Statement = ({ id, path }) => {
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState()
    
    const [
        { loading, error, fetch },
        { list: statement },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('statementBySubject', ranges ?
        { string, subject: id, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null }
        : { string, subject: id }
        , { notify: true, manual: false }, 'entries')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    return (
        <>
            <div className="col-span-full xl:col-span-8 bg-white">
                <div className="sm:flex sm:justify-between sm:items-center mb-8">
                    <input
                        onChange={e => search(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-search"
                        type="text"
                        placeholder="Search using transaction ref" />
                    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                        <RangePicker
                            onChange={selectRange}
                            ranges={{
                                'Today': [moment().startOf('day'), moment().endOf('day')],
                                'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                                'This Week': [moment().startOf('week'), moment().endOf('week')],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                            }} />
                    </div>
                </div>
                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    {
                        statement.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Details</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Debit</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Credit</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Balance</div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        statement.map((stat, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        { ((page - 1) * limit) + (key + 1)}
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ stringifyDate(stat.date, true) }</div>
                                                    <p className="mb-0 text-gray-400 text-xs italic">{ stringifyTime(stat.date) }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{stat?.type}</div>
                                                    <p className="mb-0 text-gray-400 text-xs italic">{ stat?.notes }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ stat?.amount < 0 ? stat.amount : 0 }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{ stat?.amount > 0 ? stat.amount : 0 }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-left">{ stat?.newBalance }</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No entries were found</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Bills = ({ patient, switchTab }) => {
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState([])
    const [type, setType] = useState({ label: "All", value: "All" })
    // const [inPatient, toggleInPatient] = useToggle()
    const [selected, setSelected] = useState()
    const [chosen, setChosen] = useState([])
    const [content, setContent] = useState('')
    const [title, setTitle] = useState('')
    
    const [select, toggleSelect] = useToggle()
    const [iframe, toggleIFrame] = useToggle()
    const [orderModal, toggleOrderModal] = useToggle()

    const [
        { loading, error, fetch: fetchOrders },
        { list: orders },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('hospitalBills', ranges ? { string, patient : patient?._id, type: type?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : {patient:patient?._id, type: type?.value, string }, { notify: true }, 'bills')

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }
    const changeType = val => {
        setType(val)
        refresh()
    }

    const viewOrder = ord => {
        setSelected(ord)
        toggleOrderModal()
    }

    const showPrintIFrame = (itm, ttl, cnt) => {
        setSelected(itm)
        setTitle(ttl)
        setContent(cnt)
        toggleIFrame()
    }

    const refresh = () => {
        navigate(1)
        fetchOrders()
    }

    const [{ loading: mLoading }, generateInvoice] = usePet('generateSingleInvoice', {
        ids: chosen
    }, {
        notify: true, callback: (data, notif, ops) => {
            console.log({ data })
            notif('Invoice is ready', ops('success'))
            togSelect()
            
            setTimeout(() => showPrintIFrame(data, `Invoice ${data.invoiceNo}`, 'patientInvoice'), 300)
        }, manual: true, load: { msg: 'Generating invoice...' }
    })

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                {
                    iframe &&
                    <PrintIFrame
                        content={ content }
                        visible={iframe} 
                        id={selected?._id}
                        toggle={toggleIFrame}
                        title={ title } />
                }
                {
                    orderModal &&
                    <OrderModal
                        order={selected}
                        onPerform={() => null}
                        toggle={toggleOrderModal}
                        visible={orderModal} />
                }
                <span>
                    <div className="w-full flex justify-between gap-8">
                        <input
                            onChange={e => searchSent(e.target.value)}
                            className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                            id="grid-ssearch"
                            type="text"
                            placeholder="Search for item" />
                        <Select
                            value={type}
                            onChange={changeType}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em', height: '2.5em' }) }}
                            options={['All', 'Closed', 'Open', 'Cancelled', 'Waived', 'Refunded'].map(type => ({ label: type, value: type }))}
                            placeholder="Filter By Status" />
                    </div>
                </span>
                <RangePicker onChange={selectRange} />
                {
                    chosen.length > 0 ?
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                    {
                                        chosen.length > 1 ?
                                            <Menu.Item onClick={ () => {
                                                Confirm({
                                                    title: 'Generate Invoice?',
                                                    message: 'Please confirm before generating this invoice',
                                                    okText: 'Generate Invoice',
                                                    onOk: generateInvoice
                                                })
                                            }}>Generate Single Invoice</Menu.Item>
                                            : null
                                    }
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light ml-2 text-white">
                                <span className="hidden xs:block mr-2">Bulk Actions ({chosen.length})</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                        :
                        <button onClick={togSelect} className="btn ml-2 hisani-btn-green-light text-white">
                            <BiSelectMultiple style={{ color: "white" }} />
                            <span className="hidden xs:block ml-2">{!select ? "Select" : "Deselect All"}</span>
                        </button>
                }
            </div>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        orders.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Ref No.</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Amount</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Status</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Date</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            orders.map((order, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">
                                                            {
                                                                select && !order.items.some(item => item.cancelled) ?
                                                                    <input
                                                                        onChange={() => choose(order._id)}
                                                                        checked={chosen.includes(order._id)}
                                                                        type="checkbox"
                                                                        className="form-checkbox cursor-pointer h-5 w-5" />
                                                                    :
                                                                    `${((page - 1) * limit) + (key + 1)}.`
                                                            }
                                                        </div>
                                                    </td>
                                                    {/* <td className="p-2">
                                                        <Patient patient={order?.patient} />
                                                    </td> */}
                                                    <td className="p-2">
                                                        <div className="">#{order.orderNo < 1000 ? ('00000' + order.orderNo).slice(-4) : order.orderNo}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center">Ksh. {normalize(order?.items?.filter(item => !item.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0) - (order?.discount ?? 0))}</div>
                                                        {order.items.some(item => item.cancelled) ? <p className="text-center line-through mb-0 text-red-400 text-xs italic">Ksh. {normalize(order?.items?.filter(item => item.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0) - (order?.discount ?? 0))}</p> : null}
                                                    </td>
                                                    <td className="p-2">
                                                        <div className={`text-center ${(order.waived || order.cancelled) ? 'text-red-400' : order.closed ? 'text-green-500' : 'text-yellow-500'}`}>{order.waived ? 'Waived' : order.cancelled ? 'Cancelled' : order.closed ? 'Closed' : 'Open'}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center">{stringifyDate(order.date)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={() => viewOrder(order)}>View Bill</Menu.Item>
                                                                    <Menu.Item onClick={ () => showPrintIFrame(order, `Bill #${order.orderNo}`, 'receipt') }>Print Bill</Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No receipts were found !</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Invoices = ({ patient }) => {
    const [string, setString] = useState('')
    const [content, setContent] = useState('')
    const [title, setTitle] = useState('')
    const [ranges, setRanges] = useState([])
    const [selected, setSelected] = useState()

    const [iframe, toggleIFrame] = useToggle()

    const [
        { loading, error, fetch: fetchInvoices },
        { list: invoices },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('patientInvoices', ranges ? { string, patient: patient?._id, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { patient: patient?._id, string }, { notify: true }, 'invoices')

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const showPrintIFrame = (itm, ttl, cnt) => {
        setSelected(itm)
        setTitle(ttl)
        setContent(cnt)
        toggleIFrame()
    }

    const refresh = () => {
        navigate(1)
        fetchInvoices()
    }

    // PatientInvoice bundles multiple Orders (generated via the Bills tab's
    // "Generate Invoice" action) - total is the sum across every bundled order's
    // non-cancelled items, mirroring the same per-order computation the Bills tab uses.
    const invoiceAmount = invoice => (invoice?.orders ?? []).reduce((total, order) =>
        total + (order?.items ?? [])
            .filter(item => !item.cancelled)
            .reduce((sub, itm) => sub + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0)
            - (order?.discount ?? 0), 0)

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                {
                    iframe &&
                    <PrintIFrame
                        content={ content }
                        visible={iframe}
                        id={selected?._id}
                        toggle={toggleIFrame}
                        title={ title } />
                }
                <input
                    onChange={e => searchSent(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-ssearch"
                    type="text"
                    placeholder="Search for invoice no." />
                <RangePicker onChange={selectRange} />
            </div>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        invoices.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Invoice No.</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Amount</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Orders</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Status</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Date</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            invoices.map((invoice, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">#{invoice.invoiceNo}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center">Ksh. {normalize(invoiceAmount(invoice))}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center">{invoice?.orders?.length ?? 0}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center capitalize">{invoice.status}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="text-center">{stringifyDate(invoice.date)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={ () => showPrintIFrame(invoice, 'Invoice', 'patientInvoice') }>Print Invoice</Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No invoices were found !</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const History = ({ attachedTo, patient, name, path, menuFilterItems }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState()
    const [routingGroup, setRoutingGroup] = useState({ label: 'All', value: '' })
    const [includeOthers, toggleOthers] = useToggle()

    const { user } = useSelector(state => state.application)

    const [
        { loading: itLoading, error: itError, fetch: fetchBillItems },
        { list: billItems },
        { page: itPage = 1, limit: itLimit = 10, navigate, Paginate }
    ] = useListData('billedItems', ranges ? {
        patient: patient?._id,
        attachedTo: includeOthers ? undefined : attachedTo?._id,
        string,
        routingGroup: routingGroup?.value,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { string, attachedTo: includeOthers ? undefined : attachedTo?._id, routingGroup: routingGroup?.value, patient: patient?._id }, { notify: true }, 'items')

    const refresh = () => {
        navigate(1)
        fetchBillItems()
    }

    const searchSent = str => {
        if (str?.trim()?.length > 2 || !str) {
            setString(str)
            refresh()
        }
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectOthers = () => {
        toggleOthers()
        refresh()
    }

    // get data from the issued items endpoint 
    const searchGroup = cat => {
        setRoutingGroup(cat)
        refresh()
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <span>
                    <div className="w-full flex justify-between gap-8">
                        <input
                            onChange={e => searchSent(e.target.value)}
                            className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                            id="grid-ssearch"
                            type="text"
                            placeholder="Search for item" />

                        <Select
                            styles={{ input: styles => ({ ...styles, minWidth: '10em', height: '2.5em' }) }}
                            value={routingGroup}
                            onChange={searchGroup}
                            options={[{ label: 'All', value: '' }, ...menuFilterItems.map(item => ({ label: item, value: item }))]}
                            placeholder="Select Category" />
                    </div>
                    <span>
                        <input
                            onChange={selectOthers}
                            checked={includeOthers}
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5" />
                        <span onClick={selectOthers} className="text-gray-500 cursor-pointer text-xs italic ml-2">Show {name ?? routingGroup?.label?.toLowerCase() ?? 'history'} from outside this period</span>
                    </span>
                </span>
                {
                    includeOthers &&
                    <RangePicker
                        onChange={selectRange}
                    />
                }
            </div>
            <div className="">
                <Receive
                    progress
                    loading={itLoading}
                    error={itError}>
                    {
                        billItems.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Item</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Sent By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            billItems.map((item, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((itPage - 1) * itLimit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.name} {item.quantity > 1 && ` (x ${item.quantity})`}</div>
                                                        <p className="text-gray-500 my-0 text-xs italic">Sent On {stringifyDate(item.date)}</p>
                                                        <p className={`text-${item.seen ? 'green' : 'yellow'}-500 mt-0 text-xs italic mb-0`}>{item.seen ? `Seen by ${item?.seenBy?.name}` : 'Pending'}</p>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{item.sentBy?.name}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Link to={`${path}/patients/${patient?._id}/${item._id}`} >
                                                            <button className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">{name === 'issued items' ? `No requests were made for ${patientName(patient?.name)}` : `${patientName(patient?.name)} wasn't sent for any ${routingGroup?.label?.toLowerCase() ?? 'items'}`}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Schemes = ({ authorized, patient }) => {
    const [ranges, setRanges] = useState()
    const [string, setString] = useState('')

    const [
        { loading, error, fetch },
        { list: schemes = [] },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('schemesByPatient', { id: patient?._id, string }, { notify: true }, 'schemes')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    return (
        <>
            <div className="">
                <Receive
                    progress
                    loading={loading}
                    error={error}>
                    {
                        schemes.length > 0 ?
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Scheme</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Date</div>
                                            </th>
                                            {
                                                authorized &&
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            }
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            schemes.map((scheme, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{((page - 1) * limit) + (key + 1)}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{scheme?.scheme?.name} {scheme?.main && '(Main)'}</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">Recorded on {stringifyDate(scheme.date)}</div>
                                                    </td>
                                                    {
                                                        authorized &&
                                                        <td className="p-2 text-center">
                                                            {
                                                                scheme?.scheme?.name !== 'Cash' &&
                                                                <Dropdown
                                                                    overlay={
                                                                        <Menu>
                                                                            {/* <Menu.Item onClick={() => viewPlan(plan, key)}>Edit Plan</Menu.Item>
                                                                            <Menu.Item onClick={() => removePlan(key)}>Remove Plan</Menu.Item> */}
                                                                        </Menu>
                                                                    }>
                                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                </Dropdown>
                                                            }
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full h-16 mt-4 flex items-center justify-center">
                                <p className="font-semibold text-base">No schemes were recorded for {patientName(patient?.name)}</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </>
    )
}

const Patient = ({ attachedTo, source, reload = () => null }) => {
    const [patient, setPatient] = useState()
    const [field, setField] = useState()
    const [string, setString] = useState('')
    const [val, setVal] = useState()
    const [country, setCountry] = useState()
    const [supplier, setSupplier] = useState()
    const [countries, setCountries] = useState([])
    const [regions, setRegions] = useState([])
    const [categories, setCategories] = useState([])

    const [visible, toggleVisible] = useToggle(true)

    const { user } = useSelector(state => state.application)

    const history = useHistory()
    const location = useLocation()
    const { id, pat } = useParams()
    const searchParams = new URLSearchParams(location.search)
    const focusedPreauthId = searchParams.get('preauth')
    const requestedTab = String(searchParams.get('tab') ?? '').trim().toLowerCase()
    const tabKeyMap = {
        details: '0',
        schemes: '1',
        items: '2',
        bills: '3',
        invoices: '4',
        transactions: '5',
        statements: '6',
    }
    const [activeTab, setActiveTab] = useState(tabKeyMap[requestedTab] ?? (focusedPreauthId ? '3' : '0'))

    const authorized = (user?.issuperuser || user.stations?.some(st => (st.name === 'cashier' || st.name === 'records') && (st.permissions.includes('edit-items') || st.permissions.includes('*'))))

    const [{ loading: sLoading, error: sError }] = usePet('routingGroupNames', { hidden: false }, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })

    usePet('countries', null, { notify: true, callback: ({ data }) => setCountries(data) })

    const [{ loading: rLoading }, fetchRegions] = usePet('regions', { name: patient?.country }, { manual: true, notify: true, callback: ({ data }) => setRegions(data) })

    const [{ loading: pLoading, error: pError }, getDetails] = usePet('patient', { id: pat ?? id }, {
        notify: true, callback: ({ data }) => {
            setPatient(data)
            setCountry(data?.country)
            setSupplier(data?.supplier ? { label: data?.supplier?.name, value: data?.supplier?._id } : null)
            if (data?.country) fetchRegions({ name: data.country })
        }
    })

    const [focusedPreauth, setFocusedPreauth] = useState()

    const [{ loading: preauthLoading }, fetchFocusedPreauth] = usePet('preauthStatus', {
        id: focusedPreauthId,
    }, {
        notify: false,
        manual: true,
        callback: ({ data }) => setFocusedPreauth(data),
    })

    const [
        { loading: supLoading, fetch: fetchSuppliers },
        { list: suppliers = [] }
    ] = useListData('suppliers', { string, type: 'Marketer' }, { notify: true })

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 100)
    }

    const onComplete = (_, notif, ops) => {
        reload()
        getDetails()
        setField()
        setVal()

        notif('Changes have been saved.', ops('success'))
    }

    const [{ loading }, editPatient] = usePet('editPatientDetails', {
        id: patient?._id,
        field,
        val
    }, { notify: true, load: { msg: 'Saving changes...' }, callback: onComplete, manual: true })

    const editDetails = (fld, vl) => {
        if (patient[fld] !== vl) {
            setField(fld)
            setVal(vl)
            editPatient()
        }
    }

    const searchSuppliers = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchSuppliers()
        }
    }

    const edit = fld => authorized ? { onChange: val => editDetails(fld, val) } : null

    const changeCountry = val => {
        setCountry(val?.value)
        editDetails('country', val?.value)
    }

    useEffect(() => {
        if (!focusedPreauthId) {
            setFocusedPreauth()
            return
        }

        fetchFocusedPreauth({ id: focusedPreauthId })
    }, [focusedPreauthId]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setActiveTab(tabKeyMap[requestedTab] ?? (focusedPreauthId ? '3' : '0'))
    }, [requestedTab, focusedPreauthId])

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="70%">
            <Receive
                progress
                loading={pLoading}
                error={pError}>
                {
                    patient ?
                        <>
                            <p className="font-extrabold text-3xl mb-0">Patient's Details</p>
                            {
                                focusedPreauth &&
                                <div className="rounded-sm border border-indigo-200 bg-indigo-50 px-4 py-3 mt-4 mb-2">
                                    <div className="flex flex-wrap items-start justify-between gap-3">
                                        <div>
                                            <p className="text-xs font-semibold text-indigo-800 uppercase mb-1">SHA Preauthorization in Focus</p>
                                            <p className="text-sm font-medium text-indigo-900 mb-1">
                                                {focusedPreauth?.procedureName ?? focusedPreauth?.referenceNumber ?? 'Selected preauthorization'}
                                            </p>
                                            <p className="text-xs text-indigo-800 mb-0">
                                                {focusedPreauth?.referenceNumber ? `${focusedPreauth.referenceNumber} • ` : ''}
                                                {focusedPreauth?.shaStatus ?? 'Unknown SHA status'}
                                                {focusedPreauth?.scheduledVisitDate ? ` • Visit ${stringifyDate(focusedPreauth.scheduledVisitDate)}` : ''}
                                                {focusedPreauth?.consumedAt ? ` • Consumed ${stringifyDate(focusedPreauth.consumedAt)}` : ''}
                                            </p>
                                        </div>
                                        <div className="text-xs text-indigo-700">
                                            {focusedPreauth?.consumedAt
                                                ? 'This approval has already been consumed.'
                                                : 'Use the Bills tab to continue the day-of-visit billing flow for this approval.'}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="flex items-center px-2 py-4">
                                <div className="w-28 h-28 mb-2 self-center flex items-center rounded-full justify-center overflow-hidden">
                                    <img className="h-24 w-24 mx-auto" src={images[`${patient?.gender?.toLowerCase()}_alt`] ?? images.male_alt} />
                                </div>
                                <div>
                                    <div className="flex flex-col leading-none pl-4">
                                        <p className="text-2xl font-bold mb-0">{patient?.name}</p>
                                        <p className="text-sm my-1 font-light text-gray-700">
                                            {
                                                timeDiff(patient.dob) < 0 ?
                                                    timeDiff(patient.dob, 'months') < 0 ?
                                                        timeDiff(patient.dob, 'weeks') < 0 ?
                                                            timeDiff(patient.dob, 'days') < 0 ?
                                                                timeDiff(patient.dob, 'hours')
                                                                : timeDiff(patient.dob, 'days')
                                                            : timeDiff(patient.dob, 'weeks')
                                                        : timeDiff(patient.dob, 'months')
                                                    : timeDiff(patient.dob)
                                            } Years Old (Born on {stringifyDate(patient.dob, true)})
                                        </p>
                                        {
                                            patient.ipNo &&
                                            <p className="text-gray-500 text-xs mb-0 italic">Inpatient No: {patient.ipNo}</p>
                                        }
                                        {
                                            patient.opNo &&
                                            <p className="text-gray-500 text-xs mt-0 italic">Outpatient No: {patient.opNo < 1000 ? ('00000' + patient.opNo).slice(-4) : patient.opNo}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                                <TabPane className="pl-2" key="0" tab="Details">
                                    <p className="text-gray-500 font-bold text-xs my-0">BASIC INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('name')}>{patient?.name ?? ''}</Paragraph>
                                            </div>
                                            <div className="w-full mb-3">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Date of Birth
                                                </label>
                                                {
                                                    authorized ?
                                                        <DatePicker allowClear={false} dateFormat="MM/DD/YYYY" value={moment(patient?.dob)} onChange={val => editDetails('dob', val)} />
                                                        : <Paragraph>{stringifyDate(patient.dob, true)}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Gender
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.gender, value: patient.gender }}
                                                            onChange={vl => editDetails('gender', vl.value)}
                                                            options={['Male', 'Female'].map(item => ({ label: item, value: item }))}
                                                            placeholder="Select Gender" />
                                                        : <Paragraph>{patient.gender}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">IDENTIFICATION INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Identification Type
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.documentType, value: patient.documentType }}
                                                            onChange={vl => editDetails('documentType', vl.value)}
                                                            options={['National ID', 'Millitary ID'].map(item => ({ label: item, value: item }))}
                                                            placeholder="Select ID Type" />
                                                        : <Paragraph>{patient.documentType}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Identification No.
                                                </label>
                                                <Paragraph editable={edit('identification')}>{patient?.identification ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Beneficiary CR ID
                                                </label>
                                                <Paragraph editable={edit('beneficiaryCrId')}>{patient?.beneficiaryCrId ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">CONTACT INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('phone')}>{patient?.phone ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Email
                                                </label>
                                                <Paragraph editable={edit('email')}>{patient?.email ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">RESIDENTIAL INFORMATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-2">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Country
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.country, value: patient.country }}
                                                            onChange={changeCountry}
                                                            options={countries.map(country => ({ label: country, value: country }))}
                                                            placeholder="Select Country" />
                                                        : <Paragraph>{patient.country}</Paragraph>
                                                }
                                            </div>
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Locality
                                                </label>
                                                <Paragraph editable={edit('locality')}>{patient?.locality ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Region
                                                </label>
                                                {
                                                    authorized ?
                                                        <Select
                                                            value={{ label: patient.region, value: patient.region }}
                                                            onChange={vl => {
                                                                editDetails('region', vl.value)
                                                            }}
                                                            options={regions.map(region => ({ label: region, value: region }))}
                                                            placeholder="Select Region" />
                                                        : <Paragraph>{patient.region}</Paragraph>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">IDENTIFICATION</p>
                                    <div className="grid md:grid-cols-2 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Outpatient No.
                                                </label>
                                                <Paragraph editable={edit('opNo')}>{patient?.opNo ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Inpatient No.
                                                </label>
                                                <Paragraph editable={edit('ipNo')}>{patient?.ipNo ?? ''}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">NEXT OF KIN INFORMATION</p>
                                    <div className="grid md:grid-cols-3 pl-3 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('nokName')}>{patient?.nokName}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Relationship
                                                </label>
                                                <Paragraph editable={edit('nokRShip')}>{patient?.nokRShip}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('nokPhone')}>{patient?.nokPhone}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-gray-500 font-bold text-xs my-0">BROUGHT BY</p>
                                    <div className="grid md:grid-cols-3 pl-3 sm:grid-cols-1">
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Name
                                                </label>
                                                <Paragraph editable={edit('broughtByName')}>{patient?.broughtByName}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Relationship
                                                </label>
                                                <Paragraph editable={edit('broughtByRShip')}>{patient?.broughtByRShip}</Paragraph>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                            <div className="w-full md:mb-0">
                                                <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                    Phone
                                                </label>
                                                <Paragraph editable={edit('broughtByPhone')}>{patient?.broughtByPhone}</Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                    {/* {
                                        (user?.issuperuser || user.stations?.some(st => st.name === 'marketing')) &&
                                        <>
                                            <p className="text-gray-500 font-bold text-xs my-0">MARKETING INFORMATION</p>
                                            <div className="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                                                <div className="w-full md:mb-2">
                                                    <label className="block tracking-wide text-gray-500 font-semibold mb-2" htmlFor="grid-name">
                                                        Marketer
                                                    </label>
                                                    <Creatable
                                                        onCreateOption={ () => history.push(`${source}/patients/${patient?._id}/addSupplier`) }
                                                        isLoading={supLoading}
                                                        loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                                        className="min-w-56 mr-4"
                                                        // styles={{ input: styles => ({ ...styles, minWidth: '25em' }) }}
                                                        onInputChange={searchSuppliers}
                                                        value={supplier}
                                                        onChange={setSupplier}
                                                        options={suppliers.map(supplier => ({ label: supplier.name, value: supplier._id }))}
                                                        placeholder="Search for Supplier" />
                                                </div>
                                            </div>
                                        </>
                                    } */}
                                </TabPane>
                                <TabPane key="1" tab="Schemes">
                                    <Schemes authorized={authorized} patient={patient} />
                                </TabPane>
                                <TabPane key="2" tab="Issued Items">
                                    <History
                                        path={source}
                                        name="issued items"
                                        group="Non-Medical Billed Items"
                                        attachedTo={attachedTo}
                                        menuFilterItems={categories}
                                        patient={patient} />
                                </TabPane>
                                <TabPane key="3" tab="Bills">
                                    <Bills patient={patient} />
                                </TabPane>
                                <TabPane key="4" tab="Invoices">
                                    <Invoices patient={patient} />
                                </TabPane>
                                <TabPane key="5" tab="Transactions">
                                    <Transactions id={patient._id} />
                                </TabPane>
                                <TabPane key="6" tab="Statements">
                                    <Statement id={patient._id} />
                                </TabPane>
                            </Tabs>
                        </>
                        : null
                }
            </Receive>
            <Switch>
                <Route path={`${source}/patients/:pt/addSupplier`}>
                    <NewSupplier
                        string={string}
                        onPerform={x => setSupplier({ label: x.name, value: x._id })} />
                </Route>
                <Route path={`${source}/patients/:pt/:ref`}>
                    <EntrySummary path={`${source}/patients/${patient?._id}`} />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Patient
